export default function Customization() {
  const options = [
    {
      category: 'Duration Options',
      icon: 'ri-time-line',
      items: [
        'Half-Day Workshop (4 hours)',
        'Full-Day Experience (8 hours)',
        'Multi-Day Program (2-3 days)',
        'Weekly Series (4-6 sessions)'
      ]
    },
    {
      category: 'Team Size',
      icon: 'ri-group-line',
      items: [
        'Small Teams (10-20 participants)',
        'Medium Groups (20-50 participants)',
        'Large Cohorts (50-100 participants)',
        'Company-Wide Events (100+ participants)'
      ]
    },
    {
      category: 'Add-On Experiences',
      icon: 'ri-add-circle-line',
      items: [
        'Leadership Development Module',
        'Creative Problem-Solving Sessions',
        'Wellness &amp; Mindfulness Extensions',
        'Competition Showcase Event'
      ]
    },
    {
      category: 'Venue Options',
      icon: 'ri-map-pin-line',
      items: [
        'On-site at Your Office',
        'Premium Event Space',
        'Outdoor Immersive Location',
        'Hybrid Virtual &amp; Physical'
      ]
    }
  ];

  return (
    <section className="py-32 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Customized to Your Team's Needs
          </h2>
          <p className="text-gray-300 text-xl max-w-3xl mx-auto leading-relaxed">
            Every team is unique. We tailor the Groove &amp; Glow experience to match your objectives, 
            team size, and organizational culture.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {options.map((option, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-[#1A1A2E] to-[#0F0F1A] rounded-3xl p-10 border border-white/10 hover:border-cyan-400/50 hover:shadow-2xl hover:shadow-cyan-500/10 transition-all duration-300"
            >
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center flex-shrink-0">
                  <i className={`${option.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-3xl font-bold text-white">{option.category}</h3>
              </div>
              
              <ul className="space-y-4">
                {option.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-4 group cursor-pointer">
                    <div className="w-6 h-6 rounded-full border-2 border-cyan-400 flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-cyan-400 transition-colors">
                      <i className="ri-check-line text-cyan-400 text-sm group-hover:text-black transition-colors"></i>
                    </div>
                    <span className="text-gray-300 text-lg group-hover:text-white transition-colors" dangerouslySetInnerHTML={{ __html: item }}></span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-orange-500/10 to-cyan-500/10 rounded-3xl p-12 border border-white/10 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Need Something Specific?
          </h3>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            We work closely with you to design a workshop that aligns perfectly with your team's goals, 
            challenges, and desired outcomes.
          </p>
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-cyan-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Discuss Custom Options
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
